<template>
    <div>
        <form autocomplete="off" @submit.prevent="postDatosReferenciales()">
            <vs-row class="p-4">
                <vs-col w="12" class="lineTitulo mb-2">
                    <h5><strong>DATOS REFERENCIALES</strong></h5>
                </vs-col>
                <vs-col class="inputTitulo" sm="12" lg="4">
                    <label>Matrícula SIM</label>
                    <vs-input
                        class="pt-0"
                        v-model="info.matricula_sim"
                        placeholder="Matrícula SIM"
                    />
                </vs-col>
                <vs-col class="inputTitulo" sm="12" lg="4">
                    <label>Matrícual referencial</label>
                    <vs-input
                        class="pt-0"
                        v-model="info.matricula_referencial"
                        placeholder="Matrícual referencial"
                    />
                </vs-col>
                <vs-col class="inputTitulo" sm="12" lg="4">
                    <label>Promedio primer ingreso</label>
                    <vs-input
                        class="pt-0"
                        v-model="info.prom_primer_ingreso"
                        placeholder="Promedio primer ingreso"
                    />
                </vs-col>
                <vs-col class="inputTitulo" sm="12" lg="4">
                    <label>Clave de docente</label>
                    <vs-input
                        class="pt-0"
                        v-model="info.clave_docente"
                        placeholder="Clave de docente"
                    />
                </vs-col>
                <vs-col w="12" class="mt-2">
                    <vs-button
                        success
                        type="submit"
                        class="ml-auto"
                    >
                        Guardar
                    </vs-button>
                </vs-col>
            </vs-row>
        </form>
    </div>
</template>
<script>
import alumnos from '../../../../api/requests/alumno'
export default {
    props: [
        'general',
        'personaRol'
    ],
    data(){
        return{
            info: {},
        }
    },
    computed: {
    },
    methods: {
        getInfo(){
            if(this.general.datos.datos_referenciales){
                let {matricula_sim = '', matricula_referencial = '', prom_primer_ingreso = '', clave_docente = ''} = this.general.datos.datos_referenciales
                Object.assign(this.info = {matricula_sim, matricula_referencial, prom_primer_ingreso, clave_docente})
            }
        },
        async postDatosReferenciales(){
                const loading = this.$vs.loading()
                try{
                    const params = {
                        tipo: this.general.datos.tipo,
                        matricula_sim: this.info.matricula_sim,
                        matricula_referencial: this.info.matricula_referencial,
                        prom_primer_ingreso: this.info.prom_primer_ingreso,
                        clave_docente: this.info.clave_docente
                    }
                    const {data: response} = await alumnos.postDatosReferenciales(this.general.datos.persona_id, params)
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        icon: '<i class="fas fa-check"></i>',
                        title: 'Operación éxitosa',
                        text: response.message
                    })
                    loading.close()
                    this.$emit('refreshComponent', this.general.datos.persona_id)
                }catch{
            }
        }
    },
    watch:{
        general(){
            this.getInfo()
        }
    }
}
</script>
<style>
.lineTitulo{
    border-bottom: 1px solid #dee2e6;
    margin-bottom: 3%;
}
.inputTitulo label{
    padding-left: 11px;
    margin-top: 2%;
}
</style>
